import { AutofillMonitor } from '@angular/cdk/text-field';
import {
  Component,
  ElementRef,
  Output,
  EventEmitter,
  ViewChildren,
  AfterViewInit,
  OnDestroy,
  OnInit,
  inject,
} from '@angular/core';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { FormService } from '../../form-service.service';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-form-hash',
  styleUrls: ['form-hash.component.scss'],
  template: `
    @if (props.label) {
      <label
        for="{{ field.key }}"
        class="section col-12"
        tabindex="0"
        [innerHTML]="props.label"
      ></label>
    }
    @if (props.prompt) {
      <p class="explanation" tabindex="0" [innerHTML]="props.prompt"></p>
    }
    <mat-form-field floatPlaceholder="auto" class="w-100">
      <mat-label>{{ to.placeholder }}</mat-label>
      <input
        #hash
        attr.attr.maxlength="{{ props.maxLength || maskCount }}"
        type="password"
        autocomplete="nope"
        name="hash"
        matInput
        class="real-value"
        data-lpignore="true"
        [id]="field.key"
        [placeholder]="props.placeholder || props.label"
        [formControl]="hashControl"
        [formlyAttributes]="field"
        [required]="props.required"
        (focus)="setValue($event)"
        (blur)="hasheroo($event)"
      />
      @if (props.help) {
        <span
          matTooltip="{{ props.help }}"
          aria-label="help"
          tabindex="0"
          [matTooltipPosition]="'above'"
          [matTooltipClass]="'rb-tooltip'"
        >
          <mat-icon class="col-1 help-icon"> help </mat-icon>
        </span>
      }
      @if (
        formControl.hasError('required') && !formControl.hasError('regRequired')
      ) {
        <mat-error> This field is required </mat-error>
      }
      @if (formControl.hasError('regRequired')) {
        <mat-error>
          This field is needed for suitability review. You can opt out below if
          the applicant refuses to provide the information.
        </mat-error>
      }
      @if (formControl.hasError('inputLength')) {
        <mat-error>
          Value entered must be {{ maskCount }} characters long.
        </mat-error>
      }
    </mat-form-field>
  `,
  imports: [
    FormlyModule,
    MatInputModule,
    MatIconModule,
    MatTooltipModule,
    ReactiveFormsModule,
  ],
})
export class FormlyHashComponent
  extends FieldType
  implements OnInit, AfterViewInit, OnDestroy
{
  private frmSvc = inject(FormService);
  private autofill = inject(AutofillMonitor);

  @Output() hashComplete = new EventEmitter();
  @ViewChildren('hash', { read: ElementRef }) hashFields;
  returnedHash: string;
  bullets: string;
  hashee = '';
  autofilledField = false;
  hashControl = new FormControl();
  maskCount;

  ngOnInit() {
    this.maskCount = this.field.parent.fieldGroup.find(
      field => field.key === `${this.field.key}AsteriskCount`
    )?.defaultValue;

    if (this.formControl.value) {
      if (this.maskCount && this.formControl.value.length > this.maskCount) {
        this.hashControl.setValue(
          this.formControl.value.slice(0, this.maskCount)
        );
      } else {
        this.hashControl.setValue(this.formControl.value);
      }
    }
  }

  ngAfterViewInit() {
    const hashField = this.hashFields.find(
      field => field.nativeElement.id === this.field.key
    );
    this.autofill.monitor(hashField).subscribe(e => {
      this.autofilledField = e.isAutofilled;
      if (e.isAutofilled) {
        this.formControl.setValue(null);
        this.formControl.reset();
        this.hashControl.setValue(null);
        this.hashControl.reset();
      }
    });
  }

  ngOnDestroy() {
    if (this.hashFields) {
      const hashField = this.hashFields.find(
        field => field.nativeElement.id === this.field.key
      );
      this.autofill.stopMonitoring(hashField);
    }
  }

  setValue(ev) {
    if (ev.type === 'focus' && !this.autofilledField) {
      this.hashee = this.formControl.value;
    } else if (this.autofilledField) {
      this.formControl.setValue(null);
      this.hashControl.setValue(null);
    }
  }

  hasheroo(ev) {
    if (
      ev.type === 'blur' &&
      this.hashControl.value &&
      this.hashControl.value.length > 0 &&
      !this.autofilledField
    ) {
      if (this.hashControl.value.length < this.maskCount) {
        this.hashControl.setErrors({ inputLength: true });
        this.formControl.setErrors({ inputLength: true });
      } else if (
        this.hashControl.value &&
        this.hashControl.value.length > this.maskCount
      ) {
        this.hashControl.setErrors({ inputLength: true });
        this.formControl.setErrors({ inputLength: true });
      } else {
        const sbmt = this.hashControl.value.replace(/\D/g, '');
        this.frmSvc.hashInput(sbmt, this.props.hashType).subscribe(x => {
          if (x && 'result' in x && x.result) {
            this.returnedHash = x.result;
          } else if ('resultString' in x && x.resultString) {
            this.returnedHash = x.resultString;
          }
          this.formControl.setValue(this.returnedHash);
          this.hashComplete.emit(ev);
        });
      }
    }
  }

  addToModel(field, value) {
    this.model[field] = value;
  }
}
